import { partfinitiClient } from 'core/services';

export const addProjectPricingProfile = async (payload: {
  pricingProfile: number;
  project: number;
}) => partfinitiClient.postForm('/project/pricing-profile/add', payload);

export const removeProjectPricingProfile = async (payload: { ids: number[]; project: number }) =>
  partfinitiClient.postForm('/project/pricing-profile/remove', payload);
